module.exports = __webpack_public_path__ + "img/compact.835f59ef.png";